





















import { computed, defineComponent, PropType } from 'vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import { SearchPostResult } from '../../../shared/models/responses/search/findGeneric.response';
import { mapSearchPostResultToPostModel } from '../../business/search/mapSearchPostResultToPostModel';
import Icon from '../../../shared/components/Icon.vue';
import PostHeader from '../posts/PostHeader.vue';
import { useRoute, useRouter } from 'vue-router/composables';
import SearchResultItemPostAttachments from './SearchResultItemPostAttachments.vue';
import SearchResultItemPostBody from './SearchResultItemPostBody.vue';
import SearchResultItemPostFooter from './SearchResultItemPostFooter.vue';
import { textUtil } from '../../../shared/utils/textUtil';

export default defineComponent({
  name: 'SearchResultItemPost',
  components: {
    SearchResultItemPostFooter,
    SearchResultItemPostBody,
    SearchResultItemPostAttachments,
    PostHeader,
    Icon,
  },
  props: {
    post: {
      type: Object as PropType<SearchPostResult>,
      required: true,
    },
    searchString: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const router = useRouter();
    const route = useRoute();
    const postModel = computed(() => mapSearchPostResultToPostModel(props.post));

    const openPost = () => {
      if (!router || !route) {
        return;
      }
      const routeGroupId = route.params?.groupId;
      const useGroupPostRoute = Boolean(routeGroupId);
      router.push({
        name: useGroupPostRoute ? 'group-single-post' : 'singlepost',
        params: {
          id: props.post.id,
          ...(useGroupPostRoute ? { groupId: String(routeGroupId) } : {}),
        },
      });
    };

    const searchQueries = computed(() => {
      if (!props.searchString) {
        return '';
      }
      return [textUtil.buildHighlightRegex(props.searchString)];
    });

    return {
      iconClassEnum,
      postModel,
      searchQueries,
      openPost,
    };
  },
});
